var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__a",
    d: "M0 0h21v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.746c.242 0 .438-.182.438-.407V6.915c0-.225-.196-.407-.438-.407-.241 0-.437.182-.437.407v13.424c0 .225.196.407.437.407M6.125 20.746c.242 0 .438-.182.438-.407V6.915c0-.225-.196-.407-.438-.407-.241 0-.437.182-.437.407v13.424c0 .225.196.407.437.407M14.875 20.746c.242 0 .438-.182.438-.407V6.915c0-.225-.196-.407-.438-.407-.241 0-.437.182-.437.407v13.424c0 .225.196.407.437.407",
    fillOpacity: 0.85,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "trash_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.957 21.958c-.002.125-.063 1.228-1.273 1.228H4.315c-1.196 0-1.267-1.105-1.273-1.237L2.206 3.254h16.587l-.836 18.704ZM7.128 1.09c.196-.187.44-.277.747-.277h4.375c.306 0 .551.09.747.277.352.335.493.924.542 1.35H6.585c.05-.426.192-1.015.543-1.35Zm13.434 1.35h-6.144c-.047-.508-.217-1.367-.793-1.916C13.26.177 12.798 0 12.25 0H7.875c-.548 0-1.01.177-1.376.525-.576.55-.744 1.408-.792 1.915H.437c-.241 0-.437.182-.437.407 0 .225.196.407.437.407h.894l.837 18.721c.016.7.486 2.025 2.147 2.025h12.37c1.662 0 2.13-1.325 2.147-2.017l.838-18.729h.892c.242 0 .438-.182.438-.407 0-.225-.196-.407-.438-.407Z",
    fill: "#000",
    mask: "url(#trash_svg__b)"
  }))));
};
export default SvgTrash;